import ArchivedRow from './ArchivedRow';

export default ArchivedRow;
